import { render } from "./PharmacyIcons.vue?vue&type=template&id=15941dd4"
import script from "./PharmacyIcons.vue?vue&type=script&lang=js"
export * from "./PharmacyIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__